<template>
  <div class="wrapper clearfix">
    <div
      class="demo-upload-list"
      v-for="(item, index) in imgList"
      :key="index"
      :class="{ 'demo-upload-list-img': autoImgSize || checkType(item.path) == 'mp4' }"
    >
      <template v-if="fileType == 'img'">
        <img :src="item.path" style="width: 120px" :preview="_uid" :ref="'img' + index" />
        <div class="demo-upload-list-cover" :class="{ 'ont-btn': !(isDel && !itemDisabled) }">
          <Icon
            type="ios-eye-outline"
            @click.native="handleView(item, index)"
            v-if="checkType(item.path) == 'png' || checkType(item.path) == 'jpg' || checkType(item.path) == 'jpeg' || item.path.includes('x-oss-process')"
          ></Icon>
          <Icon type="ios-trash-outline" @click.native="handleRemove(index)" v-if="isDel && !itemDisabled"></Icon>
        </div>
      </template>
      <template v-else-if="fileType == 'video' || checkType(item.path) == 'mp4'">
        <video :src="item.path || item" style="width: 120px; height: 100%" controls controlsList="nodownload" />
        <div class="demo-upload-list-cover">
          <Icon type="ios-eye-outline" @click.native="handleView(item, index)"></Icon>
          <Icon type="ios-trash-outline" @click.native="handleRemove(index)" v-if="isDel && !itemDisabled"></Icon>
        </div>
      </template>
      <template v-else>
        <div v-if="checkType(item.path) == 'pdf'">
          <img src="@/static/images/cc_pdf_new.png" class="avatar" />
          <span v-if="showFileName" class="file-name">{{ item.fileName }}</span>
        </div>
        <img v-else-if="checkType(item.path) == 'xls' || checkType(item.path) == 'xlsx'" src="@/static/images//cc_excel.png" class="avatar" />
        <img v-else-if="checkType(item.path) == 'docx' || checkType(item.path) == 'doc'" src="@/static/images/cc_word.png" class="avatar" />
        <img v-else-if="checkType(item.path) == 'ppt' || checkType(item.path) == 'pptx'" src="@/static/images/cc_ppt.png" class="avatar" />
        <img v-else :src="item.path" style="width: 120px" :preview="_uid" :ref="'img' + index" />
        <div v-if="checkType(item.path) != 'mp4'" class="demo-upload-list-cover" :class="{ 'ont-btn': !(isDel && !itemDisabled) }">
          <Icon
            type="ios-eye-outline"
            @click.native="handleView(item, index)"
            v-if="
              checkType(item.path) == 'png' ||
              checkType(item.path) == 'jpg' ||
              checkType(item.path) == 'jpeg' ||
              checkType(item.path) == 'pdf' ||
              item.path.includes('x-oss-process')
            "
          ></Icon>
          <Icon type="ios-download-outline" v-else @click.native="handleView(item, index)" />
          <Icon type="ios-trash-outline" @click.native="handleRemove(index)" v-if="isDel && !itemDisabled"></Icon>
        </div>
      </template>
    </div>
    
    <loading :isShow="uploadLoading" />
    <Upload
      v-if="isShowUpLoad && imgList.length < maxUploadLength"
      :show-upload-list="false"
      :multiple="muti ? true : false"
      type="drag"
      action="/"
      class="uploadBoxs"
      :accept="accept"
      :before-upload="handleUpload"
      :disabled="itemDisabled"
    >
      <div style="padding: 20px 0">
        <Icon type="ios-add" size="52" class="iconColor"></Icon>
        <span v-if="txt">{{ txt }}</span>
      </div>
    </Upload>
    <p class="tip" v-if="tip">{{ tip }}</p>
  </div>
</template>

<script>
import { uploadFile, uploadFilePr } from '@/api/httpList';
import _ from 'lodash';
export default {
  components: {},
  name: 'upLoad',
  props: {
    fileType: {
      type: String,
      default: 'img'
    },
    maxUploadLength: {
      type: Number,
      default: 50
    },
    maxFileSize: {
      type: Number,
      default: null
    },
    privateUpload: Boolean,
    muti: Boolean,
    txt: String,
    tip: String,
    modalWidth: String,
    isDel: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showFileName: {
      type: Boolean,
      default: false
    },
    autoImgSize: null, //上传图片自适应铺满
    value: ''
  },
  inject: {
    FormInstance: {
      default: ''
    }
  },
  data() {
    return {
      curImg: '',
      imgList: [],
      isShowMask: [],
      uploadLoading: false
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          if (newVal instanceof Array) {
            this.imgList = newVal.map(item => {
              if (item.url) {
                return item.url;
              } else {
                return item;
              }
            });
          } else {
            this.imgList = [newVal];
          }
        } else {
          this.imgList = '';
        }
      },
      immediate: true //刷新加载 立马触发一次handler
      // deep: true  // 可以深度检测到 person 对象的属性值的变化
    }
  },
  computed: {
    itemDisabled() {
      let state = this.disabled;
      if (!state && this.FormInstance) state = this.FormInstance.disabled;
      return state;
    },
    isShowUpLoad() {
      if (this.itemDisabled) {
        return false;
      }
      if (!this.muti) {
        if (this.imgList.length == 0) {
          return true;
        } else {
          return false;
        }
      } else {
        //多文件
        return true;
      }
    },
    accept() {
      if (this.fileType == 'img') {
        return '.jpg,.png,.jpeg';
      } else if (this.fileType == 'video') {
        return '.mp4';
      } else if (this.fileType == 'gif,img') {
        return '.jpg,.png,.jpeg,.gif';
      } else if (this.fileType == 'pdf,img') {
        return '.jpg,.png,.jpeg,.pdf';
      } else {
        return '';
      }
    }
  },
  methods: {
    checkType(path) {
      return path && path.split('?')[0].split('.').pop().toLowerCase();
    },
    handleView(item, index) {
      if (['png', 'jpg', 'jpeg'].includes(this.checkType(item.path)) || item.path.includes('x-oss-process')) {
        this.$refs['img' + index][0].click();
      } else if (this.checkType(item.path) == 'pdf' || this.checkType(item.path) == 'mp4') {
        window.open(item.path, '_blank');
      } else {
        location.href = item.path;
      }
    },
    handleRemove(index) {
      this.imgList.splice(index, 1);
      this.$emit('remove', index);
      this.$emit('input', this.imgList);
      this.$emit('change', this.imgList);
    },

    msg: _.throttle(
      function (txt) {
        if (this.fileType == 'pdf' && this.maxFileSize) {
          this.$notice.error(`请上传${Math.ceil(this.maxFileSize / 1024)}M以内的pdf文件`);
        } else {
          this.$notice.error(`上传格式不正确，请上传${txt.replace(/\|/g,'，')}格式文件`);
        }
      },
      2000,
      { trailing: false }
    ),

    handleUpload(file) {
      //  上传文件只能是 PDF/EXCEL/WORD/PPT/JPG/PNG 格式!
      if (this.fileType == 'img') {
        const reg = /\.(png|jpg|jpeg)$/;
        const txt = '图片';
        if (!reg.test(file.name.toLowerCase())) {
          this.msg(txt);
          return false;
        }
      } else if (this.fileType == 'video') {
        const reg = /\.(mp4)$/;
        const txt = '视频';
        if (!reg.test(file.name.toLowerCase())) {
          this.msg(txt);
          return false;
        }
      } else if (this.fileType == 'many') {
        const reg = /\.(png|jpg|jpeg|pdf|xlsx|xls|doc|docx|ppt|pptx|)$/;
        const txt = 'PDF/EXCEL/WORD/PPT/JPG/PNG';
        if (!reg.test(file.name.toLowerCase())) {
          this.msg(txt);
          return false;
        }
      } else if (this.fileType == 'any') {
        const reg = /\.(png|jpg|jpeg|pdf|xlsx|xls|doc|docx|ppt|pptx|mp4|)$/;
        const txt = 'png|jpg|jpeg|pdf|xlsx|xls|doc|docx|ppt|pptx|mp4';
        if (!reg.test(file.name.toLowerCase())) {
          this.msg(txt);
          return false;
        }
      } else if (this.fileType == 'gif,img') {
        const reg = /\.(png|jpg|jpeg|gif)$/;
        const txt = '图片';
        if (!reg.test(file.name.toLowerCase())) {
          this.msg(txt);
          return false;
        }
      } else if (this.fileType == 'pdf,img') {
        const reg = /\.(png|jpg|jpeg|pdf)$/;
        const txt = 'png|jpg|jpeg|pdf';
        if (!reg.test(file.name.toLowerCase())) {
          this.msg(txt);
          return false;
        }
      }
      if (this.maxFileSize && file.size / 1024 > this.maxFileSize) {
        this.msg();
        return false;
      }

      let formData = new FormData();
      formData.append('file', file);
      const upload = this.privateUpload ? uploadFilePr : uploadFile;
      upload(formData)
        .then(res => {
          this.handleUploadSuccess(res.data);
          if (this.muti) {
            if (this.value instanceof Array) {
              this.value.push(res.data[0]);
              this.$emit('change', this.value);
            } else {
              this.$emit('input', [res.data[0]]);
              this.$emit('change', [res.data[0]]);
            }
          } else {
            this.$emit('input', [res.data[0]]);
            this.$emit('change', [res.data[0]]);
          }
        })
        .catch(() => {});
      return false;
    },
    //
    handleUploadSuccess(res) {
      console.log(res);
    }
  }
};
</script>
<style lang="scss" scoped>
.iconColor {
  color: #3399ff;
}
.tip {
  color: #727c8e;
  width: 100%;
}
/deep/ .ivu-modal-content {
  background: transparent;
  box-shadow: none;
  outline: none;
}

/deep/ .ivu-modal-body {
  background: transparent;
}

.wrapper {
  display: flex;
  flex-wrap: wrap;
  .btn-del {
    cursor: pointer;
    margin-left: 10px;
    color: #3399ff;
  }
  .demo-upload-list {
    display: inline-block;
    width: 120px;
    height: 120px;
    text-align: center;
    line-height: 120px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    margin-right: 4px;
    margin-bottom: 4px;
  }

  .demo-upload-list:hover .file-name {
    display: none;
  }

  .demo-upload-list img {
    width: 100%;
    height: 100%;
  }

  .demo-upload-list-img {
    width: 100%;
    max-width: 280px;
    height: 173px;
    background-color: #f5f7f9;
    box-shadow: none;
    img {
      width: auto !important;
      max-width: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);

    align-items: center;
    justify-content: center;
  }

  .file-name {
    position: absolute;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    line-height: 15px;
    width: 100%;
    padding: 2px 5px;
    text-align: left;
    color: #fff;
    font-size: 12px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis; /* 超出部分省略号 */
    display: -webkit-box; /* 对象作为伸缩盒子模型显示 */
    -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
    -webkit-line-clamp: 2; /* 显示的行数 */
    max-height: 30px; /* 设置最大高度，根据行高，要几行乘以几倍 */
  }

  .demo-upload-list:hover .demo-upload-list-cover {
    display: flex;
  }

  .demo-upload-list-cover {
    &.ont-btn {
      width: 100%;
      height: 100%;
      align-items: center;
      i {
        width: 100%;
        height: 100%;
        align-items: center;
        display: flex;
        justify-content: center;
      }
    }
    i {
      color: #fff;
      font-size: 20px;
      cursor: pointer;
      padding: 10px;
    }
  }

  .imgList {
    float: left;

    li {
      position: relative;
      float: left;
      width: 120px;
      height: 120px;
      margin: 10px;

      .close {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        text-align: center;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          margin-right: 10px;
        }

        &:hover {
          cursor: pointer;

          &:last-child {
            margin-right: 0;
          }
        }
      }

      img {
        &:hover {
          cursor: pointer;
        }

        width: 100%;
        height: 100%;
      }
    }
  }

  .uploadBoxs {
    float: left;
    width: 118px;
    height: 116px;
    margin-top: 4px;

    /deep/ .ivu-upload {
      height: 100%;

      > div {
        height: 100%;
      }

      .ivu-icon {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
